import styled from "styled-components"

const ContentContainer = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  .carouselContainer:hover {
    > button {
      opacity: 1;
    }
  }
`

export { ContentContainer }
